var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("You can choose which fields can be added to table header on models list page.")]),_c('p',[_vm._v("By default all fields are used when there is no preset.")]),_c('img',{attrs:{"src":"/img/tutorials/component_list_fields.gif","width":"100%"}})])
}]

export { render, staticRenderFns }